import React from 'react';
import { useParams } from 'react-router-dom';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import { FormUpload, HtmlInput } from 'components/input';

const OtherForm = ({ form }) => {
  const { projectId } = useParams();

  return (
    <Card title="Other" style={{ marginBottom: '24px' }}>
      <FormUpload
        maxCount={1}
        label="Proposal (max. 1)"
        name="proposal"
        rules={[{ required: true, message: 'Please upload file!' }]}
        projectId={projectId}
        subFolder="PROPOSAL"
      />
      <FormUpload
        maxCount={5}
        label="Supplement(s) (max. 5)"
        name="supplements"
        projectId={projectId}
        subFolder="SUPPLEMENTS"
        multiple
      />
      <HtmlInput
        form={form}
        name="historyLog"
        label="History Log"
        required={false}
      />
      <HtmlInput
        form={form}
        name="historyLogByPMS"
        label="History Log by PMS Admin"
        required={false}
      />
    </Card>
  );
};

OtherForm.propTypes = {
  form: PropTypes.object.isRequired,
};

export default OtherForm;
